import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { securityService } from "services/SecurityService";
import { Action } from "types";

const name = "actions.action"

interface ActionState {
    actions: Action[],
    error: string | null,
    loading: Boolean
}

const initialState: ActionState = {
    actions: [],
    loading: false,
    error: ''
}

export const getActions = createAsyncThunk(`${name}/getPermissions`, async () => await securityService.getActions());

const actionsSlice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getActions.pending, state => {
            state.loading = true;
        });
        builder.addCase(getActions.fulfilled, (state, { payload }) => {
            state.loading = false;
            state.actions = payload;
        })
    }
})

export default actionsSlice.reducer;